module.exports = __webpack_public_path__ + "static/media/branch-icon.aeed0cc1.svg";